/**
 * Compare two complete URLs and check if they are the same looking only at the origin and the pathname.
 * This ignores query params and fragments.
 * @param {URL} base
 * @param {URL} comparison
 * @returns {boolean}
 */
export function compareURLsByOriginAndPathname(base: URL, comparison: URL): boolean {
    return base.origin + base.pathname === comparison.origin + comparison.pathname
}

/**
 * Tests if the given string is a valid URL.
 * @param {string} input
 * @returns {boolean}
 */
export function isValidHttpUrl(input: string) {
    let url
    try {
        url = new URL(input)
    } catch (_) {
        return false
    }

    return url.protocol === "http:" || url.protocol === "https:"
}
